<template>
  <a-modal
      :bodyStyle="{
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 10,
      paddingRight: 10,
    }"
      :footer="null"
      :visible="props.boxShow"
      title="订单盒子"
      width="50%"
      @cancel="box.handleCancel"
  >
    <div class="moda_cont">
      <a-spin :spinning="box.boxSpin">
        <a-tabs
            v-model:activeKey="box.activeKey"
            :tabBarStyle="{
            marginBottom: 0,
            border: 'none',
          }"
            centered
            @change="box.handleChangeActiveKey"
        >
          <a-tab-pane key="1">
            <template #tab>
              <a-badge
                  :count="box.orderData.statis?.activeCount"
                  :number-style="{
                  height: '15px',
                  lineHeight: '15px',
                }"
                  :offset="[10, -8]"
                  :overflowCount="999"
              >
                活跃订单
              </a-badge>
            </template>
            <div class="cont_box">
              <div class="box_cell">
                <div
                    v-for="item in box.orderData.list"
                    :key="item.id"
                    class="box_item"
                >
                  <div class="item_head">
                    <div class="head_left">
                      <div class="left_name">{{ item.order_no }}</div>
                      <div class="left_tag">
                        <span v-if="item.type == 1" class="tag"
                        >用户录入订单</span
                        >
                        <span v-if="item.type == 2" class="tag"
                        >公司录入订单</span
                        >
                        <span v-if="item.type == 3" class="tag">同步订单</span>
                        <span class="tag">{{ item.sname }}</span>
                      </div>
                    </div>
                    <div
                        class="head_right"
                        @click="oper.openOrderDetails(item)"
                    >
                      查看详情
                    </div>
                  </div>
                  <div class="item_body">
                    <div class="body_left">
                      <img :src="item.image || box.boxImage" alt=""/>
                    </div>
                    <div class="body_right">
                      <div class="right_house">
                        <span class="house_name">{{ item.name }} </span>
                        <span class="house_sn">{{ item.sn || "无锁" }}</span>
                      </div>
                      <div class="right_check">
                        <div class="check_night">
                          {{ item.start_date }} ~ {{ item.end_date }}
                        </div>
                        <div class="check_num">共{{ item.nights }}晚</div>
                      </div>
                      <!-- <div class="right_date">2022-03-02 至 2022-03-03</div> -->
                      <div class="right_person">
                        <div class="person_name">{{ item.tname }}</div>
                        <div class="person_phone">{{ item.tphone }}</div>
                      </div>
                    </div>
                    <div class="body_last">{{ item.status_text }}</div>
                  </div>
                  <div class="item_bom">
                    <div class="bom_price">
                      <div class="price_cell">
                        <div class="cell_title">总房费</div>
                        <div class="cell_num">￥{{ item.total_amount }}</div>
                      </div>
                      <div class="price_cell">
                        <div class="cell_title">佣金</div>
                        <div class="cell_num">￥{{ item.royalty }}</div>
                      </div>
                      <div class="price_cell">
                        <div class="cell_title">净房费</div>
                        <div class="cell_num">￥{{ item.room_price }}</div>
                      </div>
                    </div>
                    <div class="bom_time">
                      <div class="time_title">下单时间</div>
                      <div class="time_num">{{ item.create_time }}</div>
                    </div>
                    <div v-if="item.refund_status == 0" class="bom_oper">
                      <span
                          v-if="
                          ((item.status == 1 || item.status == 3) &&
                            item.type != 3) ||
                          item.status == 2
                        "
                          class="oper_cell"
                          @click="oper.handleCancelOrder(item)"
                      >取消订单</span
                      >
                      <span
                          v-if="item.status == 2"
                          class="oper_cell"
                          @click="oper.handleConfirmOrder(item)"
                      >确认订单</span
                      >
                      <span
                          v-if="item.status == 3 || item.status == 4"
                          class="oper_cell"
                          @click="oper.handleCheckRoom(item)"
                      >修改订单</span
                      >
                      <span
                          v-if="item.status == 4"
                          class="oper_cell"
                          @click="oper.handleCheckOut(item)"
                      >退房</span
                      >
                    </div>
                    <div
                        v-else-if="
                        item.refund_status == 1 || item.refund_status == 5
                      "
                        class="bom_oper"
                    >
                      <span
                          class="oper_cell"
                          @click="oper.handleRefuseFund(item)"
                      >拒绝退款</span
                      >
                      <span
                          class="oper_cell"
                          @click="oper.handleAgreeFund(item)"
                      >同意退款</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="box_page">
                <MyPagination
                    :pageTotal="box.orderData.count"
                    @onShowSizeChange="box.onShowSizeChange"
                    @pageChange="box.pageChange"
                />
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2">
            <template #tab>
              <a-badge
                  :count="box.orderData.statis?.historyCount"
                  :number-style="{
                  height: '15px',
                  lineHeight: '15px',
                }"
                  :offset="[10, -8]"
                  :overflowCount="999"
              >
                历史订单
              </a-badge>
            </template>
            <div class="cont_box">
              <div class="box_cell">
                <div
                    v-for="item in box.orderData.list"
                    :key="item.id"
                    class="box_item"
                >
                  <div class="item_head">
                    <div class="head_left">
                      <div class="left_name">{{ item.order_no }}</div>
                      <div class="left_tag">
                        <span v-if="item.type == 1" class="tag"
                        >用户录入订单</span
                        >
                        <span v-if="item.type == 2" class="tag"
                        >公司录入订单</span
                        >
                        <span v-if="item.type == 3" class="tag">同步订单</span>
                        <span class="tag">{{ item.sname }}</span>
                      </div>
                    </div>
                    <div
                        class="head_right"
                        @click="oper.openOrderDetails(item)"
                    >
                      查看详情
                    </div>
                  </div>
                  <div class="item_body">
                    <div class="body_left">
                      <img :src="item.image || box.boxImage" alt=""/>
                    </div>
                    <div class="body_right">
                      <div class="right_house">
                        <span class="house_name">{{ item.name }} </span>
                        <span class="house_sn">{{ item.sn || "无锁" }}</span>
                      </div>
                      <div class="right_check">
                        <div class="check_night">
                          {{ item.start_date }} ~ {{ item.end_date }}
                        </div>
                        <div class="check_num">共{{ item.nights }}晚</div>
                      </div>
                      <!-- <div class="right_date">2022-03-02 至 2022-03-03</div> -->
                      <div class="right_person">
                        <div class="person_name">{{ item.tname }}</div>
                        <div class="person_phone">{{ item.tphone }}</div>
                      </div>
                    </div>
                    <div class="body_last">{{ item.status_text }}</div>
                  </div>
                  <div class="item_bom">
                    <div class="bom_price">
                      <div class="price_cell">
                        <div class="cell_title">总房费</div>
                        <div class="cell_num">￥{{ item.total_amount }}</div>
                      </div>
                      <div class="price_cell">
                        <div class="cell_title">佣金</div>
                        <div class="cell_num">￥{{ item.royalty }}</div>
                      </div>
                      <div class="price_cell">
                        <div class="cell_title">净房费</div>
                        <div class="cell_num">￥{{ item.room_price }}</div>
                      </div>
                    </div>
                    <div class="bom_time">
                      <div class="time_title">下单时间</div>
                      <div class="time_num">{{ item.create_time }}</div>
                    </div>
                    <div v-if="item.refund_status == 0" class="bom_oper">
                      <div
                          v-if="
                          ((item.status == 1 || item.status == 3) &&
                            item.type != 3) ||
                          item.status == 2
                        "
                          class="oper_cell"
                          @click="oper.handleCancelOrder(item)"
                      >
                        取消订单
                      </div>
                      <div
                          v-if="item.status == 2"
                          class="oper_cell"
                          @click="oper.handleConfirmOrder(item)"
                      >
                        确认订单
                      </div>
                      <div
                          v-if="item.status == 3 || item.status == 4"
                          class="oper_cell"
                          @click="oper.handleCheckRoom(item)"
                      >
                        修改订单
                      </div>
                      <div
                          v-if="item.status == 4"
                          class="oper_cell"
                          @click="oper.handleCheckOut(item)"
                      >
                        退房
                      </div>
                    </div>
                    <div
                        v-else-if="
                        item.refund_status == 1 || item.refund_status == 5
                      "
                        class="bom_oper"
                    >
                      <div
                          class="oper_cell"
                          @click="oper.handleRefuseFund(item)"
                      >
                        拒绝退款
                      </div>
                      <div
                          class="oper_cell"
                          @click="oper.handleAgreeFund(item)"
                      >
                        同意退款
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box_page">
                <MyPagination
                    :pageTotal="box.orderData.count"
                    @onShowSizeChange="box.onShowSizeChange"
                    @pageChange="box.pageChange"
                />
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </div>
  </a-modal>

  <!-- 订单详情 -->
  <order-details v-model:visible="oper.detShow" :orderId="oper.orderId"/>

  <!-- 修改订单 -->
  <edit-order
      v-model:visible="oper.showEditOrder"
      :orderId="oper.orderInfo.id"
      @refresh="box.init()"
  ></edit-order>
</template>

<script setup>
import {defineEmits, defineProps, onMounted, reactive, watch} from "vue";
import OrderDetails from "@/components/pms/landlord/OrderDetails/OrderDetails.vue";
import EditOrder from "@/components/pms/landlord/EditOrder/EditOrder.vue";
import {
  agreefund,
  cancelOrder,
  checkOutRomm,
  confirmOrder,
  getOrderBox,
  getSearchList,
  getStockRoomList,
  refuseFund,
} from "@/api/api.js";
import {message, Modal} from "ant-design-vue";

const props = defineProps({
  boxShow: Boolean,
});
const emit = defineEmits(["orderBoxClose"]);
const box = reactive({
  boxImage: "",
  activeKey: "1",
  orderData: "",
  boxSpin: false,
  page: 0,
  limit: 20,
  // 关闭弹窗
  handleCancel() {
    emit("orderBoxClose");
  },
  //   切换 tab
  handleChangeActiveKey() {
    box.page = 0;
    box.limit = 20;
    box.init();
  },

  // 翻页
  pageChange(v) {
    box.page = v;
    box.init();
  },

  // 条数
  onShowSizeChange(v) {
    box.limit = v;
    box.init();
  },

  init() {
    box.boxImage = JSON.parse(sessionStorage.getItem("companyInfo") || '{}').logo || '';
    box.boxSpin = true;
    //   获取盒子订单列表
    getOrderBox({
      start: box.page,
      limit: box.limit,
      table: box.activeKey,
    })
        .then((res) => {
          box.orderData = res.data;
        })
        .finally(() => {
          box.boxSpin = false;
        });
  },
});

// 订单操作
const oper = reactive({
  detShow: false,
  orderId: "",
  // 订单详情
  openOrderDetails(item) {
    oper.orderId = item.id;
    oper.detShow = true;
  },

  // 取消订单
  handleCancelOrder(item) {
    Modal.confirm({
      title: "提示",
      content: "是否取消订单?",
      centered: true,
      onOk() {
        cancelOrder({
          order_id: item.id,
        }).then((res) => {
          message.success(res.msg);
          box.init();
        });
      },
    });
  },

  // 确认订单
  handleConfirmOrder(item) {
    confirmOrder({
      order_id: item.id,
    }).then((res) => {
      message.success(res.msg);
      box.init();
    });
  },
  // 分配房间
  house: null,
  group: null,
  orderInfo: "",
  searchList: "",
  selHouse: null,
  roomList: [],
  checkSpin: false,
  showEditOrder: false,
  handleCheckRoom(item) {
    oper.orderInfo = item;
    oper.showEditOrder = true;
    // oper.checkRoomInit().searchList();
    // oper.checkRoomInit().getStockRoomList();
  },
  checkRoomInit() {
    return {
      // 搜索列表
      searchList: function () {
        getSearchList().then((res) => {
          oper.searchList = res.data;
        });
      },
      // 查看房间
      getStockRoomList: function () {
        oper.checkSpin = true;
        getStockRoomList({
          start: 0,
          limit: 999,
          table: 1,
          rid: oper.house,
          gid: oper.group,
          start_time: oper.orderInfo.start_date,
          end_time: oper.orderInfo.end_date,
        })
            .then((res) => {
              oper.roomList = res.data;
            })
            .finally(() => {
              oper.checkSpin = false;
            });
      },
    };
  },
  checkRoomShowCancel() {
    oper.checkRoomShow = false;
  },

  // 退房
  handleCheckOut(item) {
    Modal.confirm({
      title: "提示",
      content: "是否退房?",
      centered: true,
      onOk() {
        checkOutRomm({
          order_id: item.id,
        }).then((res) => {
          message.success(res.msg);
          box.init();
        });
      },
    });
  },

  // 拒绝退款
  handleRefuseFund(item) {
    refuseFund({
      order_id: item.id,
    }).then((res) => {
      message.success(res.msg);
      box.init();
    });
  },

  // 同意退款
  handleAgreeFund(item) {
    agreefund({
      order_id: item.id,
    }).then((res) => {
      message.success(res.msg);
    });
  },
});
watch(
    () => props.boxShow,
    (n) => {
      if (n) {
        box.init();
      }
    }
);
onMounted(() => {
});
</script>

<style lang="scss" scoped>
.moda_cont {
  // overflow-y: scroll;
  // height: 80vh;

  .cont_box {
    // min-height: 600px;
    // overflow-y: auto;
    .box_cell {
      height: 70vh;
      overflow-y: scroll;

      .box_item {
        background-color: #f7f8fa;
        margin-bottom: 16px;
        border-radius: 6px;

        &:last-child {
          padding-bottom: 0;
          margin-bottom: 0;
        }

        .item_head {
          padding: 15px 20px;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #ccc;

          .head_left {
            display: flex;

            .left_name {
              margin-right: 10px;
              font-weight: bold;
            }

            .left_tag {
              .tag {
                background-color: #e9f3ff;
                color: #0094ff;
                padding: 3px 6px;
                margin: 0 6px;
                border-radius: 3px;
              }
            }
          }

          .head_right {
            color: #0094ff;
            cursor: pointer;
          }
        }

        .item_body {
          padding: 15px 20px;
          border-bottom: 1px solid #ccc;
          display: flex;

          .body_left {
            width: 140px;
            height: 80px;
            background-color: pink;
            border-radius: 10px;
            overflow: hidden;
            margin-right: 15px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .body_right {
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .right_house {
              .house_name {
                margin-right: 10px;
              }

              .house_sn {
                color: #ccc;
              }
            }

            .right_check {
              display: flex;

              .check_night {
                margin-right: 10px;
              }

              .check_num {
              }
            }

            .right_date {
              color: #ccc;
            }

            .right_person {
              display: flex;

              .person_name {
                margin-right: 10px;
              }

              .person_phone {
              }
            }
          }

          .body_last {
            flex: 1;
            text-align: right;
            color: #dd0054;
            font-weight: bold;
          }
        }

        .item_bom {
          padding: 15px 20px;
          display: flex;
          align-items: center;

          .bom_price {
            display: flex;

            .price_cell {
              display: flex;
              margin-right: 10px;

              &:last-child {
                margin-right: 20px;
              }

              .cell_title {
                color: #ccc;
                margin-right: 6px;
              }

              .cell_num {
                color: #dd0054;
              }
            }
          }

          .bom_time {
            display: flex;

            .time_title {
              color: #ccc;
              margin-right: 6px;
            }

            .time_num {
            }
          }

          .bom_oper {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            height: 30px;

            .oper_cell {
              background-color: #0094ff;
              width: 80px;
              text-align: center;
              padding: 3px 0;
              margin: 0 6px;
              color: #ffffff;
              border-radius: 4px;
              cursor: pointer;
            }
          }
        }
      }
    }

    .box_page {
      // height: 10%;
      display: flex;
      justify-content: center;
      padding: 10px 0;
    }
  }
}

.room {
  height: 60vh;
  overflow: auto;

  .room_box {
    display: flex;
    align-items: center;
    // background-color: pink;

    .box_img {
      margin-right: 10px;
      border-radius: 6px;
      overflow: hidden;
    }

    .box_name {
      .name_h {
      }

      .name_r {
      }
    }
  }
}
</style>
